import { GalleryContext } from "./chunk-JMBPVZMW.js";
import { Button_default } from "./chunk-JORIQT5S.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Gallery/Gallery.Button.tsx
import { forwardRef, useContext, useMemo, useCallback } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var GALLERY_BUTTON_CLASSNAME_MAP = {
  variant: {
    prev: "pd:top-1/2 pd:-translate-y-1/2 pd:left-3",
    next: "pd:top-1/2 pd:-translate-y-1/2 pd:right-3",
    zoom: ""
  }
};
var DEFAULT_COMPONENT = Button_default;
var GalleryButton = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      variant = "next",
      screenReaderLabel,
      disabled: disabledProp,
      onClick,
      "aria-controls": ariaControls,
      className
    } = _b,
    rest = __objRest(_b, ["as", "variant", "screenReaderLabel", "disabled", "onClick", "aria-controls", "className"]);
  const Component = as || DEFAULT_COMPONENT;
  const {
    id,
    activeItem,
    setActiveItem,
    totalItems
  } = useContext(GalleryContext);
  const disabled = disabledProp || variant === "prev" && activeItem === 1 || variant === "next" && activeItem === totalItems;
  const icon = useMemo(() => {
    if (variant === "next") {
      return "chevron-right";
    }
    if (variant === "prev") {
      return "chevron-left";
    }
    return "zoom-plus";
  }, [variant]);
  const handleClick = useCallback(event => {
    if (variant === "next") {
      setActiveItem(Math.min(activeItem + 1, totalItems));
    }
    if (variant === "prev") {
      setActiveItem(Math.max(activeItem - 1, 1));
    }
    onClick == null ? void 0 : onClick(event);
  }, [onClick, variant, activeItem, setActiveItem, totalItems]);
  return /* @__PURE__ */jsx(Component, __spreadProps(__spreadValues({
    ref
  }, rest), {
    variant: "white-circle",
    type: "button",
    "aria-controls": ariaControls || (variant !== "zoom" ? "".concat(id, "-items") : void 0),
    iconBefore: icon,
    disabled,
    onClick: handleClick,
    className: clsx(variant !== "zoom" && "pd:gallery__button", GALLERY_BUTTON_CLASSNAME_MAP.variant[variant], className),
    children: /* @__PURE__ */jsx("span", {
      className: "pd:sr-only",
      children: screenReaderLabel
    })
  }));
});
var Gallery_Button_default = GalleryButton;
export { Gallery_Button_default };